import { ProductType } from '@syf-api-library/account-summary'
import { SECURED_INSTALLMENT } from 'const/productTypes'

import isAccountTypeSecuredInstallment from './isAccountTypeSecuredInstallment'
import isAccountTypeSetpayOrPaylater from './isAccountTypeSetpayOrPaylater'

const isLoanAccount = (type: ProductType | typeof SECURED_INSTALLMENT) => {
  return (
    isAccountTypeSetpayOrPaylater(type as ProductType) ||
    isAccountTypeSecuredInstallment(type)
  )
}

export default isLoanAccount
